<template>
    <div class="nav-environments">

        <div class="button">
            <a class="computa"
               v-on:click="setShowPage('computacenter')"
            >
                <img src="@/assets/images/icons/compitacenter.svg"/>
            </a>
        </div>
        <div class="button postoffice">
            <a class="postoffice"
               v-on:click="setShowPage('intel')"
            >
                <img src="@/assets/images/icons/post-office-white.svg"/>
            </a>
        </div>
        <div class="env-menu">
            <div class="head-env dropdown-obj"
                 v-click-outside="clickOutMenu"
            >
                <a class="dropdown-action dropdown-toggle"
                   v-on:click="dropdawnShow = !dropdawnShow"
                   v-bind:class="{ active: dropdawnShow }"
                   v-html="headMenuTitle"
                >
                    {{headMenuTitle}}


                </a>
                <div class="dropdown-menu desktop"
                     v-if="dropdawnShow"
                >
                    <a class="dropdown-item"
                       v-for="(value, key) in navEnvList"
                       :key="key"
                       @click.prevent="setActiveEnv(value.id)"
                       v-html="value.title"
                    >
                        {{ value.title }}
                    </a>
                </div>
                <div class="dropdown-menu"
                     v-if="dropdawnShow"
                >
                    <div
                        v-for="(value, key) in navEnvList"
                        :key="key"
                    >
                        <a class="dropdown-item"
                           v-if="value.subenv"
                           :key="key"
                           v-bind:class="{'show-submenu':value.showSubMenu, 'submenu':value.subenv }"
                           @click.prevent="value.showSubMenu = !value.showSubMenu"

                        >
                            <div
                                v-bind:class="{'subtitle':value.subenv }"
                                v-html="value.title"
                            >
                            </div>
                            <div class="sub-menu"
                                 v-for="(itemsub, key) in value.subenv"
                                 :key="key"
                            >
                                <a class="dropdown-item"
                                   @click.prevent="setActiveEnv(itemsub.id)"
                                   v-html="itemsub.title"
                                >
                                </a>
                            </div>
                        </a>
                        <a class="dropdown-item"
                           v-else
                           @click.prevent="setActiveEnv(value.id)"
                           v-html="value.title"
                        >
                            {{ value.title }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="sub-env">
                <slidenav
                    v-bind:subenv="activParentEnvironment.subenv"
                    v-bind:activSubEnvironment="activSubEnvironment"
                    v-on:setActiveEnv="setActiveEnv"
                    v-if="activParentEnvironment.subenv"
                />
            </div>

            <div class="typesol"
                 v-if="false"
            >
                <switcher
                    v-bind:switchDisable="switchDisable"
                    v-bind:typeSol="typeSol"
                    v-on:change="changeSwitcher"
                />

            </div>
        </div>
        <div class="button home digitalplace">
            <router-link :to="{ name: 'Landing' }" class="home">
                <img src="@/assets/images/icons/homeicon.svg"/>
            </router-link>
        </div>
    </div>
</template>

<script>
    import switcher from '@/components/system/switcher.vue'
    import slidenav from '@/components/system/slidenav.vue'

    export default {
        name: "NavEnv",
        props: ['curentEnvironment', 'switchDisable', 'typeSol', 'selectEnvironments', 'activeEnv', 'displayType'],
        data() {
            return {
                headMenuTitle: '',
                dropdawnShow: false,
                // typeSolCheck: false, // false = (Digital Workplace), true = (Smart Infrastructure)
                parent: '', // curent menu element
                subenv: '', // list sumenv menu elements

                // selectedParentEnv: false,
                // selectedSubEnv: false,

                activParentEnvironment: false,
                activSubEnvironment: false,
                navEnvList: false,
            }
        },
        computed: {},
        watch: {
            'activeEnv'() {
                this.setActivNavEnvironment();
            },
            'displayType'() {
                this.setHeadMenuTitle();
            }
        },
        mounted() {
            this.setHeadMenuTitle();
            this.createNavEnvList();
        },
        methods: {
            setShowPage(page) {

                if (page == 'intel') {
                    if (this.curentEnvironment.slug == "data-center") {
                        this.$emit('setShowPage', 'intel-page-datacenter');
                    } else {
                        this.$emit('setShowPage', 'intel-page');
                    }

                } else if (page == 'computacenter') {
                    if (this.curentEnvironment.slug == "data-center") {
                        this.$emit('setShowPage', 'computacenter-page-datacenter')
                    } else {
                        this.$emit('setShowPage', 'computacenter-page')
                    }
                }
            },
            createNavEnvList() {
                //create nav list width all environments
                let navList = [];
                this.globalData.environments.forEach((item) => {
                    let item_element = {
                        id: item.id,
                        title: item.title,
                        showSubMenu: false,
                    }
                    if (item.grouptype) {
                        item_element.subenv = this.globalData.environments.filter((el) => {
                            return el.parent == item.id;
                        });
                        navList.push(item_element)
                    } else if (!item.parent) {
                        navList.push(item_element)
                    }
                });
                this.navEnvList = navList;
                this.setActivNavEnvironment();
            },
            setActivNavEnvironment() {
                let el = this.globalData.environments.find((el) => {
                    return el.id == this.activeEnv;
                });
                if (typeof el === 'object') {

                    if (Object.prototype.hasOwnProperty.call(el, "parent")) {

                        this.activParentEnvironment = this.navEnvList.find((elem) => {
                            return elem.id == el.parent;
                        });
                        this.activSubEnvironment = el;


                    } else {
                        this.activParentEnvironment = el;
                        this.activSubEnvironment = false;
                    }

                } else {
                    this.activParentEnvironment = false;
                    this.activSubEnvironment = false;
                }
                this.setHeadMenuTitle();
            },
            changeSwitcher() {
                this.$emit('changeTypeSol', !this.typeSol);
            },
            clickOutMenu() {
                this.dropdawnShow = false;
            },
            setActiveEnv(env_id) {
                this.dropdawnShow = false;
                this.$emit('setActiveEnv', env_id);
            },
            setHeadMenuTitle() {
                if (this.displayType == 'desk') {
                    this.headMenuTitle = this.activParentEnvironment.title;
                } else {
                    if (this.activSubEnvironment) {
                        this.headMenuTitle = this.activSubEnvironment.title
                    } else {
                        this.headMenuTitle = this.activParentEnvironment.title;
                    }
                }

            }
            //
            //
            // setMenu() {
            //     if (this.curentEnvironment.id) {
            //
            //         let elEnv = this.globalData.environments.filter((el) => {
            //             return el.id == this.curentEnvironment.id;
            //         });
            //         if (elEnv[0].parent) {
            //             //if environment has a parent
            //             let elx = this.globalData.environments.filter((el) => {
            //                 return el.id == elEnv[0].parent;
            //             });
            //             this.parent = elx[0]
            //         } else {
            //             this.parent = elEnv[0];
            //         }
            //     }
            // },
            // changeParent(envID) {
            //     let elEnv = this.globalData.environments.filter((el) => {
            //         return el.id == envID;
            //     });
            //     if (elEnv[0].grouptype) {
            //         let elSubEnv = this.globalData.environments.filter((el) => {
            //             return el.parent == envID;
            //         })
            //         this.$emit('setEnvirement', elSubEnv[0].id);
            //
            //     } else {
            //         this.$emit('setEnvirement', elEnv[0].id);
            //     }
            //     this.dropdawnShow = false;
            // },
            // setSubEnv() {
            //     // create sub-menu
            //
            //     if (this.parent && this.parent.grouptype && this.parent.slug == 'groupbank') {
            //         let elSubEnvs = this.globalData.environments.filter((el) => {
            //             return (el.parent == this.parent.id);
            //         })
            //         this.subenv = elSubEnvs;
            //
            //     } else if (this.parent && this.parent.grouptype) {
            //         let elSubEnvs = this.globalData.environments.filter((el) => {
            //             return ((el.parent == this.parent.id) && (this.selectEnvironments.indexOf(el.id) != -1));
            //         })
            //
            //         this.subenv = elSubEnvs;
            //
            //     } else {
            //         this.subenv = false;
            //     }
            // },

        },
        components: {
            switcher,
            slidenav
        },
    }
</script>

<style lang="scss" scoped>

</style>